import axios from "axios";

import { API_BASE_URL } from "./apiBase";

/**
 * Dedicated anonymous presentation HTTP client.
 * Never attaches a bearer token, never refreshes, never logs out,
 * and never persists tokens or presentation payloads.
 */
const publicPresentationApi = axios.create({
  baseURL: API_BASE_URL,
});

export default publicPresentationApi;
